import { adminApiIndex as apiIndex } from '../constant';
import { adminClient1, adminClient as client } from './client';

//PC_FG_121
export const getSecAudits = async (data) => {
    try {
        //PC_FG_122
        let body = {
            modulename: apiIndex.modulename.login,
            methodname: apiIndex.methodname.getSecAudits,
            payload: data,
        };
        //PC_FG_123
        const response = await client(body);
        //PC_FG_125
        return response;
    } catch (error) {
        throw error;
    }
};

//PC_FG_127
export const getGRC = async (data) => {
    try {
        //PC_FG_128
        let body = {
            modulename: apiIndex.modulename.login,
            methodname: apiIndex.methodname.getGRC,
            payload: data,
        };
        //PC_FG_129
        const response = await client(body);
        //PC_FG_131
        return response;
    } catch (error) {
        throw error;
    }
};

export const getLogin = async (data) => {
    //debugger;
    const res = await client(data);

    //debugger;

    return res;
};
export const getRefreshToken = async (data) => {

    return await adminClient1(data);
};

export const getroleName = async (empID) => {
    try {
        let body = {
            modulename: apiIndex.modulename.login,
            methodname: apiIndex.methodname.GetRoleName,
            payload: { empID },
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getLeaveData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.leaveData,
            methodname: apiIndex.methodname.getLeaveData,
            payload: {},
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};
export const postLeaveData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.leaveData,
            methodname: apiIndex.methodname.postLeaveData,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateLeaveData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.leaveData,
            methodname: apiIndex.methodname.updateLeaveData,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteLeaveData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.leaveData,
            methodname: apiIndex.methodname.deleteLeaveData,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postAnnouncementData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.announcement,
            methodname: apiIndex.methodname.postAnnouncement,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getAnnouncement = async (data = {}) => {
    try {
        let body = {
            modulename: apiIndex.modulename.announcement,
            methodname: apiIndex.methodname.getAnnouncement,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateAnnoucementData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.announcement,
            methodname: apiIndex.methodname.updateAnnouncement,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteAnnoucementData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.announcement,
            methodname: apiIndex.methodname.deleteAnnouncement,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getTeamMoodData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.getTeamMood,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postTeamMoodData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.postTeamMood,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateTeamMoodData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.updateTeamMood,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getMoodCategoryData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.getTeamMoodCategory,
            payload: {},
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postMoodCategoryData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.postTeamMoodCategory,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateMoodCategoryData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.updateTeamMoodCategory,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteMoodCategoryData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.teammood,
            methodname: apiIndex.methodname.deleteTeamMoodCategory,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getEvaluationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.evaluvation,
            methodname: apiIndex.methodname.getEvaluation,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postEvaluationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.evaluvation,
            methodname: apiIndex.methodname.postEvaluation,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateEvaluationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.evaluvation,
            methodname: apiIndex.methodname.updateEvaluation,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteEvaluationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.evaluvation,
            methodname: apiIndex.methodname.deleteEvaluation,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateEvaluationGoalData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.evaluvation,
            methodname: apiIndex.methodname.updateEvaluationGoal,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getHolidayData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.getHoliday,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getHolidayIconsList = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.getHolidayIcon,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postHolidayData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.postHoliday,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateHolidayData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.updateHoliday,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteHolidayData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.deleteHoliday,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getOffboadingTemplateData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.getOffboardingTemplate,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postOffboadingTemplateData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.postOffboardingTemplate,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateOffboadingTemplateData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.updateOffboardingTemplate,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteOffboadingTemplateData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.deleteOffboardingTemplate,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getOffboadingTemplateTaskData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.getOffboardingTemplateTask,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postOffboadingTemplateTaskData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.postOffboardingTemplateTask,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateOffboadingTemplateTaskData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.updateOffboardingTemplateTask,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteOffboadingTemplateTaskData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.offboarding,
            methodname: apiIndex.methodname.deleteOffboardingTemplateTask,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getRecruitmentMessageData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.getRecruitmentMessage,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postRecruitmentMessageData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.postRecruitmentMessage,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateRecruitmentMessageData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.updateRecruitmentMessage,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteRecruitmentMessageData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.deleteRecruitmentMessage,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getFresherQuestionData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.getFresherQuestion,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {
        throw error;
    }
};

export const postFresherQuestionData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.postFresherQuestion,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateFresherQuestionData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.updateFresherQuestion,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteFresherQuestionData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.deleteFresherQuestion,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getDepartmentData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.department,
            methodname: apiIndex.methodname.getDepartmentData,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getDesiginationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.getAllDesigination,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postDesiginationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.postDesigination,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {
        throw error;
    }
};

export const updateDesiginationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.updateDesigination,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteDesiginationData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.deleteDesigination,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getGroupData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.groups,
            methodname: apiIndex.methodname.getAllGroup,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postGroupData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.groups,
            methodname: apiIndex.methodname.postGroup,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {
        throw error;
    }
};

export const updateGroupData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.groups,
            methodname: apiIndex.methodname.updateGroup,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteGroupData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.groups,
            methodname: apiIndex.methodname.deleteGroup,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getWeekendData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.getWeekend,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postWeekendData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.postWeekend,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateWeekendData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.updateWeekend,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteWeekendData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.holiday,
            methodname: apiIndex.methodname.deleteWeekend,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getOfferletterData = async () => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.getOfferletter,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postOfferletterData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.postOfferletter,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {
        throw error;
    }
};

export const updateOfferletterData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.updateOfferletter,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteOfferletterData = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.recruitment,
            methodname: apiIndex.methodname.deleteOfferletter,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getProfileImage = async (data) => {
    try {
        let body = {
            modulename: apiIndex.modulename.department,
            methodname: apiIndex.methodname.getOfferletter,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};
